import formsIcon from '../assets/images/siteImg/icon-checklist-forms-and-documents.svg';
import learningCoachIcon from '../assets/images/siteImg/icon-checklist-learning-coach-life.svg';
import onlineSchoolIcon from '../assets/images/siteImg/icon-checklist-online-school.svg';
import schoolEmailIcon from '../assets/images/siteImg/icon-checklist-school-email.svg';

// Category-to-Icon Mapping
export const categoryIcons: { [key: string]: string } = {
  "forms-and-documents": formsIcon,
  "learning-coach-life": learningCoachIcon,
  "online-school": onlineSchoolIcon,
  "school-email": schoolEmailIcon
};

export const filterChecklistsByRole = (
    checklistData: any[],
    checklistTopicStatus: any[],
    userRole: string | null,
    baseUrl: string,
    hasNonHighSchoolStudents: boolean
  ) => {
    // Define which categories each role can see
    const roleCategoryMap: { [key: string]: string[] } = {
      LEARNING_COACH: ["FORMS_AND_DOCUMENTS", "LEARNING_COACH_LIFE", "ONLINE_SCHOOL", "SCHOOL_EMAIL"],
      STUDENT: ["ONLINE_SCHOOL", "SCHOOL_EMAIL"],
    };
  
    // Get allowed categories based on role
    const allowedCategories = roleCategoryMap[userRole || ""] || [];
  
    // Group by category
    const categoryMap = new Map();
  
    checklistData.forEach((item) => {
      const shouldInclude = allowedCategories.includes(item.checklistCategoryName)
      && item.roles.includes(userRole)
      && (hasNonHighSchoolStudents || item.checklistName !== "CONSENT_PROCESS");

      if (shouldInclude) {
        if (!categoryMap.has(item.checklistCategoryName)) {
          categoryMap.set(item.checklistCategoryName, []);
        }
  
        const checklistStatus = checklistTopicStatus.find((status) => status.checklistId === item.checklistId);
        const checklistItem = {
          checklistId: item.checklistId,
          title: item.description,
          checklistNameFormat: item.checklistName,
          linkUrl: `${baseUrl}/${item.checklistName.toLowerCase().replace(/_/g, "-")}`,
          // status: checklistStatus ? (checklistStatus.status === "true" ? "Completed" : "Begin Topic") : "Begin Topic",
        };
  
        categoryMap.get(item.checklistCategoryName).push(checklistItem);
      }
      console.log("Filtered Checklist shouldInclude:", shouldInclude);

    });

    return categoryMap;
};
// Utility to format category names (e.g., "FORMS_AND_DOCUMENTS" → "Forms And Documents")
export const formatCategoryName = (category: string): string => {
  return category
    .toLowerCase()
    .replace(/_/g, " ") // Replace underscores with spaces
    .split(" ")
    .map(word => word.charAt(0).toUpperCase() + word.slice(1)) // Capitalize each word
    .join(" ");
};

 
export const getChecklistStatus = (checklistId: string, checklistTopicStatus: any[]) => {
  // const checklistStatus = checklistTopicStatus.find((status) => status.checklistId == checklistId);
  const checklistStatus = checklistTopicStatus.find((status) => Number(status.checklistId) === Number(checklistId));
  // console.log(checklistStatus );
  return checklistStatus ? (checklistStatus.status === "true" ? "Completed" : "Begin Topic") : "Begin Topic";
};

export const getCurrentChecklistId = (checklistData: any[], checklistName: string) => {
  if (!checklistData.length) return null; // case when data is empty
  const checklistItem = checklistData.find(item => item.checklistName === checklistName);
  return checklistItem ? checklistItem.checklistId.toString() : null;
};

// Utility to calculate completion percentage
export const calculateCompletionPercentage = (topics: { status: string }[]): number => {
  if (!topics || topics.length === 0) return 0;
  const completedTopics = topics.filter(topic => topic.status === "Completed").length;
  return Math.round((completedTopics / topics.length) * 100);
};

// Reusable Code Calculate Percentage
export const calculateChecklistCompletion = (
  checklistData: any[],
  categoryName: string,
  completedChecklistIds: string[],
  hasNonHighSchoolStudents: boolean
): number => {
  if (!checklistData || checklistData.length === 0) return 0; // empty data

  // Get topics in the given category
  const categoryTopics = checklistData.filter(item => item.checklistCategoryName == categoryName && (hasNonHighSchoolStudents || item.checklistName !== "CONSENT_PROCESS") );
  if (categoryTopics.length === 0) return 0; // No topics found

  // Count completed topics
  const completedTopics = categoryTopics.filter(topic => completedChecklistIds.includes(topic.checklistId)).length;

  // console.log(checklistData, categoryTopics , completedTopics );
  return categoryTopics.length > 0 ? Math.floor((completedTopics / categoryTopics.length) * 100) : 0;
};

// get StyleValue for background color progressBar
export const getBgColorStyleValue = (percentage: number): number => percentage / 100;

// Calculate percentage with filterTopics hidden Exclude
export const calculateChecklistCompletion_2 = (
  filteredTopics: any[],  
  completedChecklistIds: string[] // Already extracted completed IDs
): number => {
  // console.log("Filtered Topics:", filteredTopics);

  if (!filteredTopics || filteredTopics.length === 0) return 0; // Empty data check

  // Count only completed topics
  const completedTopics = filteredTopics.filter(topic => completedChecklistIds.includes(topic.checklistId)).length;

  // console.log("Completed Topics Count:", completedTopics);

  // Calculate percentage (Ensure proper rounding)
  return filteredTopics.length > 0 ? Math.floor((completedTopics / filteredTopics.length) * 100) : 0;
};



